export const productAction = {
  FETCH_PRODUCT_REQUEST: "FETCH_PRODUCT_REQUEST",
  FETCH_PRODUCT_SUCCESS: "FETCH_PRODUCT_SUCCESS",
  FETCH_PRODUCT_SHOPCART: "FETCH_PRODUCT_SHOPCART",
  UPDATE_PRODUCT_SHOPCART: "UPDATE_PRODUCT_SHOPCART",
  SET_PRODUCT_STATE: "SET_PRODUCT_STATE",

  fetchProductShopCart: (loading = false) => ({
    type: productAction.FETCH_PRODUCT_SHOPCART,
    payload: { loading: loading },
  }),

  updateProductShopCart: (data) => ({
    type: productAction.UPDATE_PRODUCT_SHOPCART,
    payload: data,
  }),

  setProductState: (data) => ({
    type: productAction.SET_PRODUCT_STATE,
    payload: data,
  }),
}
